import { Button } from 'react-bootstrap'
import { periodos } from 'data/constants'

const RowTablePeriodoFacultad = ({ faculty, setFaculty, setShowModal }) => {
    const validateDate = () => {
        let fecha = new Date()
        let anio = fecha.getFullYear()
        let dia = fecha.getDate().toString().padStart(2, '0')
        let mes = (fecha.getMonth() + 1).toString().padStart(2, '0') //
        let fechaActual = `${anio}-${mes}-${dia}`

        if (fechaActual >= faculty.fecha_inicio && fechaActual <= faculty.fecha_fin) {
            return 'Habilitado'
        }
        return 'Deshabilitado'
    }

    const updatePeriod = () => {
        setFaculty(faculty)
        setShowModal(true)
    }

    return (
        <tr key={faculty.id} style={{ verticalAlign: 'middle' }}>
            <td>{faculty.gestion}</td>
            <td>{faculty.nombre}</td>
            <td>{periodos[faculty.periodo]}</td>
            <td>{faculty.fecha_inicio}</td>
            <td>{faculty.fecha_fin}</td>
            <td>
                <div className={validateDate() === 'Habilitado' ? 'btn-enable' : 'btn-disable'}>{validateDate()}</div>
            </td>
            <td style={{ textAlign: 'center' }} className='acciones'>
                <Button onClick={() => updatePeriod()} variant='blue' className='py-0 px-4'>
                    Editar
                </Button>
            </td>
        </tr>
    )
}

export default RowTablePeriodoFacultad
